import { AdminAccount } from 'api-calls/account';

// Below this many unused backup codes, suggest new ones (same as TwoFactor).
const LOW_BACKUP_CODES = 3;

export type ItemState = 'done' | 'todo' | 'off';

export interface ChecklistItem {
  key: string;
  title: string;
  state: ItemState;
  status: string;
  description: string;
  action?: { label: string; to: string };
}

// The sign-in protections on the staff account. After Google sign-in, staff
// enter a second code: from their authenticator app once it is set up,
// otherwise one sent to their email.
export function securityChecklist(account: AdminAccount): ChecklistItem[] {
  const authenticator = account.two_factor_enabled;
  const backupCodesLeft = account.backup_codes_left ?? 0;

  const items: ChecklistItem[] = [
    {
      key: 'google',
      title: 'Đăng nhập bằng Google',
      state: 'done',
      status: 'Đang dùng',
      description: `Tài khoản Google ${account.email}.`,
    },
    {
      key: 'email-otp',
      title: 'Mã xác thực qua email',
      state: authenticator ? 'off' : 'done',
      status: authenticator ? 'Đã thay bằng ứng dụng xác thực' : 'Đang dùng',
      description: authenticator
        ? 'Khi đã bật ứng dụng xác thực, đăng nhập không dùng mã qua email nữa.'
        : 'Sau khi đăng nhập Google, bạn nhập mã 6 số được gửi đến email công việc.',
    },
    {
      key: 'authenticator',
      title: 'Ứng dụng xác thực (Google Authenticator)',
      state: authenticator ? 'done' : 'todo',
      status: authenticator
        ? 'Đã bật'
        : account.two_factor_required
          ? 'Bắt buộc với vai trò của bạn'
          : 'Chưa bật (khuyến nghị)',
      description: authenticator
        ? 'Sau khi đăng nhập Google, bạn nhập mã 6 số từ ứng dụng trên điện thoại.'
        : 'An toàn hơn mã qua email: mã nằm trên điện thoại của bạn, không nằm trong hộp thư có thể bị lộ cùng tài khoản Google.',
      action: {
        label: authenticator ? 'Quản lý' : 'Thiết lập',
        to: '/two-factor',
      },
    },
  ];

  if (authenticator) {
    const low = backupCodesLeft <= LOW_BACKUP_CODES;
    items.push({
      key: 'backup-codes',
      title: 'Mã dự phòng',
      state: low ? 'todo' : 'done',
      status: `Còn ${backupCodesLeft} mã`,
      description: low
        ? 'Bạn sắp hết mã dự phòng, dùng khi mất điện thoại. Tạo lại bằng cách tắt và bật lại xác thực hai lớp, hoặc nhờ quản trị viên đặt lại.'
        : 'Dùng khi mất điện thoại. Mỗi mã dùng được một lần.',
    });
  }
  return items;
}
